module.exports = fox._r("fonts/museosanscyrl-webfont.svg", __webpack_public_path__ + "fonts/museosanscyrl-webfont.svg");


//////////////////
// WEBPACK FOOTER
// ./fonts/museosanscyrl-webfont.svg
// module id = 577
// module chunks = 2